import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import {  getAboutOverview  } from '../../api'; // Import from api.js


// Async thunk for fetching dashboard data
export const fetchAboutOverviewData = createAsyncThunk(
  'aboutOverview/fetchAboutOverviewData',
  async (_, { rejectWithValue }) => {
    try {
      // Use the function from api.js
      const data = await getAboutOverview();
      return data;
    } catch (error) {
      return rejectWithValue(error.message || 'Failed to fetch aboutOverview data');
    }
  }
);

const aboutOverviewSlice = createSlice({
  name: 'aboutOverview',
  initialState: {
    data: null,
    loading: false,
    error: null,
  },
  reducers: {
    resetError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchAboutOverviewData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchAboutOverviewData.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(fetchAboutOverviewData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { resetError } = aboutOverviewSlice.actions;
export default aboutOverviewSlice.reducer;
